import { render } from "./dualList.vue?vue&type=template&id=cd7fcbf4"
import script from "./dualList.vue?vue&type=script&lang=js"
export * from "./dualList.vue?vue&type=script&lang=js"

import "./dualList.vue?vue&type=style&index=0&id=cd7fcbf4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__